import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import classnames from 'classnames'

class StepLayout extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const classes = {
      'prev-item': this.props.current == this.props.step+1,
      'active-item': this.props.current == this.props.step,
      'next-item': this.props.current == this.props.step-1
    }

    return(
      <div className={classnames('form-wizard__step', classes)} >
        <div className="container">
          <div className="row">
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

export default StepLayout

